import { Company } from '@treasury/domain/backoffice/services/company';

export class CompanyViewModel extends Company {
    public get active() {
        return this.dto.status?.toLowerCase() === 'active';
    }

    public set active(value: boolean) {
        this.dto.status = value ? 'Active' : 'Inactive';
    }

    public get customerSinceString() {
        const { customerSince } = this;
        return customerSince.toLocaleDateString();
        // Leaving this here for now in case we need to use the year difference again
        // return this.dto.customerSince ? this.getDateStringWithYearDiff(customerSince) : '';
    }

    public get treasuryCustomerSinceString() {
        const { treasuryCustomerSince } = this;
        return treasuryCustomerSince.toLocaleDateString();
        // Leaving this here for now in case we need to use the year difference again
        // return this.dto.addedOn ? this.getDateStringWithYearDiff(treasuryCustomerSince) : '';
    }

    public get authenticationMethodOptions() {
        return [
            { name: 'Out-of-Band', value: 1 },
            { name: 'Secure Token', value: 2 },
        ];
    }

    public get authenticationProfileOptions() {
        return this.challengeGroups.map(group => ({
            name: group.name,
            value: group.id,
        }));
    }

    constructor(entity: Company) {
        super(entity.toDto(), entity.challengeGroups);
    }

    /**
     * Returns a formatted date string with the difference in years from the given date.
     * If the difference is zero, returns the date in the format "MM/DD/YYYY".
     * Otherwise, returns the date in the format "MM/DD/YYYY (yearsDifference years)".
     *
     * @param date - The date to calculate the difference from.
     * @returns The formatted date string.
     */
    private getDateStringWithYearDiff(date: Date) {
        const now = new Date();
        let yearsDifference = 0;

        if (isNaN(date.getTime())) {
            return '';
        }

        if (date) {
            const diffInMilliseconds = now.getTime() - date.getTime();
            const diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365); // Convert milliseconds to years
            yearsDifference = Math.floor(diffInYears); // Get the full years difference
        }
        if (yearsDifference === 0) {
            return date.toLocaleDateString();
        }
        return `${date.toLocaleDateString()} (${yearsDifference} years)`;
    }
}
